import styled from 'styled-components'

export const CityPageContext = styled.div`
  background-color: ${props => props.theme.colors.white};
`



// WEBPACK FOOTER //
// ./src/Components/City/Page/Context/index.js